import { render, staticRenderFns } from "./InformationIcon.vue?vue&type=template&id=2ad0cfe6&scoped=true"
import script from "./InformationIcon.vue?vue&type=script&lang=js"
export * from "./InformationIcon.vue?vue&type=script&lang=js"
import style0 from "./InformationIcon.vue?vue&type=style&index=0&id=2ad0cfe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0cfe6",
  null
  
)

export default component.exports